import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface AcademySettingsSectionProps {
  title: string;
  description?: string;
  divider?: 'top' | 'none';
  headerAside?: ReactNode;
  contentClassName?: string;
  children: ReactNode;
  className?: string;
  id?: string;
}

export function AcademySettingsSection({
  title,
  description,
  divider = 'top',
  headerAside,
  contentClassName = 'mt-8',
  children,
  className,
  id,
}: AcademySettingsSectionProps) {
  return (
    <section
      id={id}
      className={cn(
        'pb-5',
        divider === 'top' && 'border-t border-border pt-5',
        className
      )}
    >
      <div className={cn('flex flex-col gap-4', headerAside && 'sm:flex-row sm:items-start sm:justify-between')}>
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">{title}</h3>
          {description ? (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
          ) : null}
        </div>
        {headerAside ? <div className="shrink-0">{headerAside}</div> : null}
      </div>
      <div className={contentClassName}>{children}</div>
    </section>
  );
}
